export const AdobeLogo = ({className = '', size = 32}) => {
  return (
    <svg
      className={className}
      style={{width: size, height: size}}
      viewBox="0 0 501.71 444.05">
      <path
        d="m297.58 444.05-36.45-101.4h-91.46l76.87-193.53 116.65 294.93h138.52L316.8 0H186.23L0 444.05h297.58z"
        fill="#eb1000" />
    </svg>
  );
};
